import React, { useEffect, useMemo } from "react";
import TopItems from "./topItems";
import useOrientation from "../libs/hooks/useOrientation";
import { calcNumColumns } from "src/customer/utils/storeItemUtils";
import translate from "../libs/locale";
import useCategories from "../libs/hooks/useCategories";
import { QUERY_UTIL } from "../libs/utils/dataUtils";

const TopItemContainer = () => {
  const orientation = useOrientation();
  const { categories, loading } = useCategories();

  const numColumnsTopItems = useMemo(() => {
    return calcNumColumns(orientation, 1);
  }, [orientation]);

  return (
    <>
      {/* <TopItems
        numColumns={numColumnsTopItems}
        title={translate("topItems")}
        query={{
          rating: QUERY_UTIL.rating,
          limit: QUERY_UTIL.limit,
          is_available: true,
        }}
        horizontal
      /> */}
      {categories?.map((cat) => {
        return (
          <TopItems
            key={cat._id}
            numColumns={numColumnsTopItems}
            title={cat.name}
            query={{
              category: cat.id,
              limit: QUERY_UTIL.limit,
              is_available: true,
            }}
            horizontal
          />
        );
      })}
    </>
  );
};

export default TopItemContainer;
